var _circle, _circle2, _circle3, _circle4, _path, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimatic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 236,
    viewBox: "0 0 215 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 10,
    r: 10,
    fill: "#140F33"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 111,
    r: 10,
    fill: "#140F33"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 110,
    r: 10,
    fill: "#140F33"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 226,
    r: 10,
    fill: "#140F33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.6957 228L10 110.304L110.797 8L205 164.06L127.047 110.304L63.6957 228Z",
    stroke: "#140F33",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10 111.156H127.082L112.24 6M64.1827 226L206 163.379",
    stroke: "#140F33",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205,
    cy: 164.5,
    rx: 10,
    ry: 9.5,
    fill: "#140F33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatic);
export default __webpack_public_path__ + "static/media/Animatic.ec028d3dcaaa96d8dbd030c741a6ee2b.svg";
export { ForwardRef as ReactComponent };